@if (transcript(); as t) {
  <div class="agent-history__detail">
    <button type="button" class="agent-history__back" mat-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      {{ "agent.history.back" | translate }}
    </button>
    <h3 class="agent-history__detail-title">{{ t.summary.title }}</h3>
    @for (turn of turns(); track turn.messageId) {
      <div class="agent-history__turn">
        @if (turn.userMessage) {
          <div class="agent-history__user">{{ turn.userMessage }}</div>
        }
        @for (call of turn.toolCalls; track $index) {
          <div class="agent-history__tool" [class.agent-history__tool--error]="call.isError">
            <mat-icon>{{ call.isError ? "error_outline" : "build" }}</mat-icon>
            <span>{{ call.label | translate }}</span>
          </div>
        }
        @if (turn.responseText) {
          <div class="agent-history__assistant agent-md" [innerHTML]="turn.responseText | markdown: 'link'" (click)="onContentClick($event)"></div>
        }
      </div>
    }
  </div>
} @else {
  <div class="agent-history__list">
    @if (errored()) {
      <p class="agent-history__state agent-history__state--error">{{ "agent.history.error" | translate }}</p>
    } @else if (items().length === 0 && !loading()) {
      <div class="agent-history__empty">
        <mat-icon>history</mat-icon>
        <p>{{ "agent.history.empty" | translate }}</p>
      </div>
    } @else {
      @for (item of items(); track item.conversationId) {
        <button type="button" class="agent-history__item" (click)="open(item)">
          <span class="agent-history__item-title">{{ item.title }}</span>
          <span class="agent-history__item-meta">
            {{ item.lastActivityAt | date: "short" }} · {{ "agent.history.turns" | translate: { count: item.turnCount } }}
          </span>
        </button>
      }
      @if (hasMore()) {
        <button type="button" class="agent-history__more" mat-button [disabled]="loading()" (click)="loadMore()">
          {{ "agent.history.load-more" | translate }}
        </button>
      }
    }
    @if (loading()) {
      <p class="agent-history__state">{{ "agent.history.loading" | translate }}</p>
    }
  </div>
}
